<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-download"></i> Export Inquiry Report
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="offset-md-2 col-md-8">
        <div class="row">
          <div class="col-md-6">
            <mat-form-field class="mat-block">
              <mat-select formControlName="year" placeholder="Year" required>
                <mat-option *ngFor="let year of years" [value]="year">{{year}}</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('year').touched && form.get('year').hasError('required')">
                Year is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="mat-block">
              <mat-select formControlName="month" placeholder="Month" required>
                <mat-option *ngFor="let month of months" [value]="month">{{month}}</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('month').touched && form.get('month').hasError('required')">
                Month is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <app-select-search bindValue="id"
                               bindLabel="name"
                               floatLabel="never"
                               [items]="rentals$ | async"
                               [ctrl]="form.get('rentals')"
                               placeholder="Select Rental(s)">
              <ng-container class="error-container">
                <mat-error *ngIf="form.get('rentals').touched && form.get('rentals').hasError('required')">
                  Rentals(s) is <strong>required</strong>
                </mat-error>
              </ng-container>
            </app-select-search>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-checkbox formControlName="onlyBooked">Only Booked</mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button (click)="download(form)" type="button" class="btn btn-success text-uppercase create-btn"
          [disabled]="isExporting">
    <i class="fal fa-cloud-download"></i> export
  </button>
</div>
